export async function submitLogin(axios, loginData) {
  try {
    if (loginData) {
      const loginPostURL = 'ticket/all/' + loginData.Token + '/';
      return await axios.get(loginPostURL);
    }
  } catch (e) {
    if (e.response) {
      if (e.response.status === 404) {
        throw new Error('Token not found');
      }
      const errorCode = e.response.data.code;
      if (errorCode === 'submit_failed' || errorCode === 'unknown_error') {
        throw new Error('Form submission fail');
      }
    }
    throw new Error(e?.response?.data?.message);
  }
}

export async function getAllCategories(axios) {
  try {
    const getAllCategoriesURL = 'ticket/category/';
    return await axios.get(getAllCategoriesURL);
  } catch (e) {
    if (e.response) {
      const errorCode = e.response.data.code;
      if (errorCode === 'submit_failed' || errorCode === 'unknown_error') {
        throw new Error('Form submission fail');
      }
    }
    throw new Error(e?.response?.data?.message);
  }
}
